

export const MIDIA_OPTIONS_CALL_CENTER = [
    {id: 1, ds_midia: "Telefone"},
    {id: 2, ds_midia: "Whatsapp"},
    {id: 3, ds_midia: "E-mail"},
    {id: 4, ds_midia: "Balcão"},
    {id: 5, ds_midia: "Telefone e Whatsapp"},
]

export const MIDIA_OPTIONS_CANAL_DIRETO = [
    {id: 1, ds_midia: "Telefone"},
    {id: 2, ds_midia: "Whatsapp"},
    {id: 3, ds_midia: "E-mail"},
    {id: 4, ds_midia: "Balcão"},
    {id: 5, ds_midia: "Telefone e Whatsapp"},
]

export const MIDIA_OPTIONS_TELEFONIA_CALL_CENTER = [
    {id: 1, ds_midia: "Telefone"},
    {id: 2, ds_midia: "Whatsapp"},
    {id: 3, ds_midia: "E-mail"},
    {id: 5, ds_midia: "Telefone e Whatsapp"},
]

export const MIDIA_OPTIONS_TELEFONIA_CANAL_DIRETO = [
    {id: 1, ds_midia: "Telefone"},
    {id: 2, ds_midia: "Whatsapp"},
    {id: 3, ds_midia: "E-mail"},
    {id: 5, ds_midia: "Telefone e Whatsapp"},
]
